(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('marketplace', {
                parent: 'entity',
                url: '/marketplace?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.marketplace.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/marketplace/marketplaces.html',
                        controller: 'MarketplaceController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('marketplace');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            })
            .state('marketplace-detail', {
                parent: 'entity',
                url: '/marketplace/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.marketplace.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/marketplace/marketplace-detail.html',
                        controller: 'MarketplaceDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('marketplace');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Marketplace', function ($stateParams, Marketplace) {
                        return Marketplace.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('marketplace.new', {
                parent: 'marketplace',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketplace/marketplace-dialog.html',
                        controller: 'MarketplaceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    managerType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('marketplace', null, {reload: true});
                    }, function () {
                        $state.go('marketplace');
                    });
                }]
            })
            .state('marketplace.edit', {
                parent: 'marketplace',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketplace/marketplace-dialog.html',
                        controller: 'MarketplaceDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Marketplace', function (Marketplace) {
                                return Marketplace.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('marketplace', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('marketplace.delete', {
                parent: 'marketplace',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketplace/marketplace-delete-dialog.html',
                        controller: 'MarketplaceDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Marketplace', function (Marketplace) {
                                return Marketplace.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('marketplace', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
